import { render, staticRenderFns } from "./StatsValidesMyCoreg.vue?vue&type=template&id=00e96e81&"
import script from "./StatsValidesMyCoreg.vue?vue&type=script&lang=js&"
export * from "./StatsValidesMyCoreg.vue?vue&type=script&lang=js&"
import style0 from "./StatsValidesMyCoreg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports